import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Col, Table, Button } from 'react-bootstrap';

import { MainPageApi } from '../main-page/main-page.api';
import { dictionary } from '../../assets/dictionary';
import { useDispatch, useSelector } from 'react-redux';
import { STORE } from '../redux-configs';
import {
    ACTIONS,
    updateEmergencyFromAllEmergenciesActionCreator as updateEmergencyActionCreator,
} from '../actions';
import MedicalCardModal from '../medical-card-modal/medical-card-modal';
import StepsModal from '../steps-modal/steps-modal';
import useWindowDimensions from '../hooks/use-window-dimensions';
import './details-table.scss';

const mainPageApi = MainPageApi.getInstance();

export function DetailsTable(props) {
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();
    const { showSteps, setShowSteps } = props;
    const [data, setData] = useState([]);
    const { selectedEmergency } = useSelector(STORE);
    const [operator, setOperator] = useState(null);
    const [showUserMedicalCard, setShowUserMedicalCard] = useState(false);

    useEffect(() => {
        let operator = null;
        if (selectedEmergency.status === 'inProgress') {
            operator = selectedEmergency?.logs?.find(l => l.workStatus === 'PROCESSING')?.operator?.username;
        } else if (selectedEmergency.status === 'finished') {
            operator = selectedEmergency?.logs?.find(l => l.workStatus === 'FINISHED')?.operator?.username;
        }
        setOperator(operator);
    }, [selectedEmergency?.logs, selectedEmergency?.status]);

    const toggleDetailsTable = () => {
        dispatch({
            type: ACTIONS.CLEAR_SELECTED_EMERGENCY,
        });
        window.scrollTo(0, 0);
    };

    const updateStatus = async (newStatus) => {
        await mainPageApi.updateEmergencyStatus(
            selectedEmergency['id'],
            newStatus
        );
        const logStatus =
            newStatus === 'inProgress' ? 'PROCESSING' : 'FINISHED';
        const log = await mainPageApi.pushEmergencyLog(selectedEmergency, logStatus);
        delete log.emergency;
        const updatedEmergency = {
            ...selectedEmergency,
            logs: [...(selectedEmergency.logs ?? []), log],
            status: newStatus,
        };
        dispatch(updateEmergencyActionCreator(updatedEmergency));
        dispatch({
            type: ACTIONS.SET_SELECTED_EMERGENCY,
            payload: updatedEmergency,
        });
    };

    const handleProcess = async () => {
        await updateStatus('inProgress');
        setShowSteps(true);
    };

    useEffect(() => {
        let d = Object.entries(
            _.omit(selectedEmergency, [
                'createdAt',
                'updatedAt',
                'user',
                'messageType',
                'logs',
                'id',
            ])
        );
        d = [d[0], ...d];
        d[1] = ['user', selectedEmergency.user?.medicalCard?.firstName];
        setData(d);
    }, [selectedEmergency]);

    return (
        <Col className="col-5 details-table"
             style={{
                 width: width <= 800 ? '100%' : '35%',
                 height: width > 800 ? '100%' : '',
                 overflowY: 'scroll'
             }}>
            <Table striped hover bordered responsive style={{
                fontSize: '14px',
                lineHeight: '16px'
            }}>
                <tbody>
                    {data.map(([key, value], index) => {
                        if ('user' === key) {
                            if (value) {
                                return (
                                    <tr key={key}>
                                        <td>{dictionary['firstName']}</td>
                                        <td>{value}</td>
                                    </tr>
                                )
                            }
                            return undefined;
                        }
                        if (
                            ['finishReason', 'notes', 'finishedAt'].includes(
                                key
                            ) &&
                            value == null
                        )
                            return undefined;
                        if (index === 0) {
                            return (
                                <tr key={key}>
                                    <td>{dictionary[key]}</td>
                                    <td className="cell-w-close-button">
                                        {dictionary[`${value}`] || value}
                                        <span
                                            className="close-button"
                                            onClick={() => toggleDetailsTable()}
                                        >
                                            X
                                        </span>
                                    </td>
                                </tr>
                            );
                        }
                        return (
                            <tr key={key}>
                                <td>{dictionary[key]}</td>
                                {key === 'status' && (
                                    <td>{dictionary[`${value}`] + (operator ? ` (${ operator })` : '')}</td>
                                )}
                                {key !== 'status' && (
                                    <td>{dictionary[`${value}`] || value}</td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <div className="in-row">
                <Button
                    className="emergency-button"
                    variant="outline-dark"
                    disabled={!selectedEmergency?.user?.medicalCard}
                    onClick={() => setShowUserMedicalCard(true)}
                >
                    Медична карта
                </Button>
                {selectedEmergency?.status === 'pending' && (
                    <Button
                        variant="warning"
                        className="emergency-button"
                        onClick={handleProcess}
                    >
                        В роботу
                    </Button>
                )}
                {selectedEmergency?.status === 'inProgress' && (
                    <Button
                        variant="success"
                        className="emergency-button"
                        onClick={() => setShowSteps(true)}
                    >
                        Завершити
                    </Button>
                )}
            </div>
            {showUserMedicalCard && selectedEmergency?.user?.medicalCard && (
                <MedicalCardModal
                    show={showUserMedicalCard}
                    setShow={setShowUserMedicalCard}
                    medicalCard={selectedEmergency?.user?.medicalCard}
                />
            )}
            {showSteps && (
                <StepsModal show={showSteps} setShow={setShowSteps} />
            )}
        </Col>
    );
}
